export default __webpack_public_path__ + "static/media/Hair_10_M_C2.44768c13.svg";